import type { Language, Region } from '@lemonade-hq/lemonation';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type State = {
  lang: Language | undefined;
  region: Region | undefined;
};

interface UseLangAndRegion extends State {
  setLangAndRegion: (state: Partial<UseLangAndRegion>) => void;
}

const initialState: State = {
  lang: undefined,
  region: undefined,
};

export const useLangAndRegion = create<UseLangAndRegion>()(
  devtools(set => ({
    ...initialState,
    setLangAndRegion: args => set({ ...args }),
  })),
);
